import gql from "graphql-tag";

export default gql`
query {
  getCurrentUser {
    id
    email
    name
    role
  }
}
`;
